// Catálogo canônico dos modos de impressão (a tela/fluxo que originou a ordem)
// e dos canais de saída (por onde o ZPL sai). Ambos são gravados no histórico
// e aparecem nos Logs de Impressão, por isso os valores precisam ser estáveis:
// mudar uma string aqui quebra a leitura dos registros antigos.

export const MODOS_IMPRESSAO = {
  AVULSA: "Impressão Avulsa",
  SSCC: "Impressão SSCC",
  BIPAGEM: "Impressão por Bipagem",
  REIMPRESSAO: "Reimpressão",
  PLANILHA: "Impressão Planilha",
  XML: "Impressão XML",
  PEDIDO: "Impressão Pedido",
  GRAVACAO_AVULSA: "Gravação Avulsa",
  // Fallback para ordens disparadas por um caminho que não informou o modo.
  NAO_INFORMADO: "Impressão",
} as const;

export type ModoImpressao =
  (typeof MODOS_IMPRESSAO)[keyof typeof MODOS_IMPRESSAO];

export const CANAIS_IMPRESSAO = {
  MODULO: "Módulo RFID",
  USB: "USB",
  LEGACY: "Legacy",
} as const;

export type CanalImpressao =
  (typeof CANAIS_IMPRESSAO)[keyof typeof CANAIS_IMPRESSAO];

/**
 * Deriva o canal de saída a partir da configuração da conta. As duas flags são
 * mutuamente exclusivas na prática; se ambas vierem ligadas, USB vence porque é
 * o caminho testado primeiro em `imprimirItem`.
 */
export function resolverCanalImpressao(
  config?: {
    impressao_usb?: string;
    impressao_legacy?: string;
  } | null,
): CanalImpressao {
  if (config?.impressao_usb === "true") return CANAIS_IMPRESSAO.USB;
  if (config?.impressao_legacy === "true") return CANAIS_IMPRESSAO.LEGACY;
  return CANAIS_IMPRESSAO.MODULO;
}
